export default [
  require(`./css-modules-by-example/frontmatter`),
  require(`./how-to-style-react/frontmatter`)
];



// WEBPACK FOOTER //
// ./src/guides/index.js